import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

class Photo extends React.Component {
    constructor(props) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        event.preventDefault();
        this.props.openPhotoLightBox(this.props.index);
    }

    render() {
        const { photo } = this.props;
        return (
            <a
                className="vehicleBanner-photo"
                onClick={this.handleClick}
                href={photo}
                title={LocaleService.t('IMAGE_NUMBER', { number: this.props.index + 1 })}
            >
                <img src={photo} alt={LocaleService.t('IMAGE_NUMBER', { number: this.props.index + 1 })} />
            </a>
        );
    }
}

Photo.propTypes = {
    photo: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    openPhotoLightBox: PropTypes.func.isRequired,
};

Photo.displayName = 'Photo';

export default Photo;



// WEBPACK FOOTER //
// ./src/Vehicle/components/VehicleBannerWithCarrousel/Photo/Photo.jsx